export default "__VITE_ASSET__78375172__"